import { parseDoc, type Doc } from './docs';

// Carrega todos os .md desta pasta no build (texto cru). Ver docs.ts para o formato.
// `legal/` (Política de privacidade e Termos de uso) fica de fora: são páginas públicas sem
// cabeçalho de tela, carregadas direto por `?raw` em src/pages/public/.
const files = import.meta.glob(['./**/*.md', '!./legal/**'], { query: '?raw', import: 'default', eager: true }) as Record<string, string>;

export const DOCS: Doc[] = Object.entries(files).map(([file, text]) => parseDoc(file, text).doc);

export const DOC_PROBLEMS: string[] = Object.entries(files).flatMap(([file, text]) => parseDoc(file, text).problems);

export * from './docs';
